<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="
              all(props.index)
                ? 'red lighten-1'
                : propRequired(header.value, props.index)
            "
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array,
    },
    properties: {
      default: () => [],
      type: Array,
    },
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false,
      },
      {
        text: "Relationship",
        value: "relationship",
        sortable: false,
      },
      {
        text: "Address",
        value: "address",
        sortable: false,
      },
      {
        text: "Lastname",
        value: "lastName",
        sortable: false,
      },
      {
        text: "Firstname",
        value: "firstName",
        sortable: false,
      },
      {
        text: "Middlename",
        value: "middleName",
        sortable: false,
      },
      /*RLV:30Jun2022*/
      {
        text: "Gender",
        value: "gender",
        sortable: false,
      },
      /*RLV:30Jun2022*/
      {
        text: "Nationality",
        value: "citiCode",
        sortable: false,
      },
      {
        text: "Occupation",
        value: "occupation",
        sortable: false,
      },
      {
        text: "Contact No",
        value: "contactNo",
        sortable: false,
      },
      {
        text: "Birth Date",
        value: "birthDate",
        sortable: false,
      },
      {
        text: "Beneficiary",
        value: "beneficiary",
        sortable: false,
      },
      {
        text: "Insurance",
        value: "insurance",
        sortable: false,
      },
      {
        text: "Purpose",
        value: "purpose",
        sortable: false,
      },
      {
        text: "School",
        value: "school",
        sortable: false,
      },
      {
        text: "Dependent",
        value: "dependent",
        sortable: false,
      },
      {
        text: "Incapacitated",
        value: "incapacitated",
        sortable: false,
      },
    ],
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter((item) => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "FAMILYINFO"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter((item) => {
        return (
          item.property == "ALL" &&
          item.mode == "FAMILYINFO" &&
          item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    },
  },
};
</script>
